import { tenantCommercialRulesSchema, type TenantCommercialRules } from '@console/types'
import { customerAppGet, customerAppPut } from '../customer-app.js'

export async function fetchTenantCommercialRules(): Promise<TenantCommercialRules> {
  return customerAppGet('/api/v1/tenant-config/commercial-rules', tenantCommercialRulesSchema)
}

export async function saveTenantCommercialRules(
  rules: TenantCommercialRules,
): Promise<TenantCommercialRules> {
  return customerAppPut(
    '/api/v1/tenant-config/commercial-rules',
    rules,
    tenantCommercialRulesSchema,
  )
}
